import React from 'react';
import {
    SkeletonContainer,
    SkeletonLine,
    ImageSkeleton,
    CampaignCardSkeleton,
    CampaignListSkeleton,
} from '../styled';
import Wrapper from '../../../ui/Wrapper';

const CampaignSkeleton = ({ itemCount = 1 }) => {
    const renderSkeletonCard = () =>
        Array.from({ length: itemCount }, (_, index) => (
            <CampaignCardSkeleton key={`campaigns_${index}`}>
                <ImageSkeleton />
                <Wrapper padding={'24px 36px'} boxSizing={'border-box'}>
                    <SkeletonLine
                        height={'16px'}
                        margin={'0 0 12px'}
                        radius={'8px'}
                    />
                    <SkeletonLine
                        height={'16px'}
                        width={'80%'}
                        margin={'0'}
                        radius={'8px'}
                    />
                </Wrapper>
            </CampaignCardSkeleton>
        ));

    return (
        <SkeletonContainer
            background={'transparent'}
            padding={'0'}
            overflow={'initial'}
        >
            <CampaignListSkeleton>{renderSkeletonCard()}</CampaignListSkeleton>
        </SkeletonContainer>
    );
};

export default CampaignSkeleton;
